/**
 * @description Constants for Mission Control card types
 */

// Card type constants
export const MC_CARD_TYPE_ALERT = 'alert';
export const MC_CARD_TYPE_LAST_EXPERIENCE = 'last-experience';
export const MC_CARD_TYPE_NEXT_JOB = 'next-job';

// Card type union
export type McCardType =
  | typeof MC_CARD_TYPE_ALERT
  | typeof MC_CARD_TYPE_LAST_EXPERIENCE
  | typeof MC_CARD_TYPE_NEXT_JOB;

// Source type constants for keyword searches
export const MC_KEYWORD_SOURCE_LAST_EXPERIENCE = 'last-experience';
export const MC_KEYWORD_SOURCE_NEXT_JOB = 'next-job';

export type McKeywordSource =
  | typeof MC_KEYWORD_SOURCE_LAST_EXPERIENCE
  | typeof MC_KEYWORD_SOURCE_NEXT_JOB;
